import { Plus, MessageSquare, Trash2, X } from "lucide-react";
import { useChatsStore } from "../../store/chats";
import { cn } from "../../lib/cn";

export function ChatList() {
  const sessions = useChatsStore((s) => s.sessions);
  const activeId = useChatsStore((s) => s.activeId);
  const switchChat = useChatsStore((s) => s.switchChat);
  const createChat = useChatsStore((s) => s.createChat);
  const deleteChat = useChatsStore((s) => s.deleteChat);

  return (
    <div className="flex flex-col h-full">
      <button
        onClick={() => createChat()}
        className="flex items-center gap-2 px-3 py-2 mx-2 mb-2 rounded-card border border-border/60 hover:bg-bg-subtle text-small font-medium transition-colors"
      >
        <Plus className="size-4" />
        Новый чат
      </button>
      <div className="flex-1 overflow-y-auto space-y-0.5 px-1">
        {sessions.map((s) => (
          <div
            key={s.id}
            className={cn(
              "group flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer text-small transition-colors",
              s.id === activeId
                ? "bg-bg-subtle text-fg"
                : "text-fg-muted hover:bg-bg-subtle/50 hover:text-fg",
            )}
            onClick={() => switchChat(s.id)}
          >
            <MessageSquare className="size-3.5 shrink-0" />
            <span className="flex-1 truncate">{s.title}</span>
            {sessions.length > 1 && (
              <button
                onClick={(e) => { e.stopPropagation(); deleteChat(s.id); }}
                className="opacity-0 group-hover:opacity-100 p-0.5 hover:text-red-400 transition-opacity"
                aria-label="Удалить чат"
              >
                <X className="size-3.5" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
